import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql, Link } from 'gatsby';
import {
  SSection,
  SSectionTitle,
  SCategoryItem,
  SCategoryName,
  SCategoryTotalPosts,
  SAllLink,
} from './styles';

function BlogCategoryListCard() {
  const [categoryList, setCategoryList] = useState([]);
  const { allWpCategory } = useStaticQuery(
    graphql`
      query {
        allWpCategory(filter: { count: { gt: 0 } }) {
          nodes {
            posts {
              nodes {
                id
                slug
              }
            }
            slug
            name
            id
          }
        }
      }
    `,
  );

  useEffect(() => {
    setCategoryList(allWpCategory.nodes);
  }, [allWpCategory]);

  return (
    <SSection>
      <SSectionTitle>Categories</SSectionTitle>
      {categoryList.map(category => {
        return (
          <SCategoryItem key={category.id}>
            <Link to={`/blog/categories/${category.slug}/1/`}>
              <SCategoryName>{category.name}</SCategoryName>
            </Link>
            <SCategoryTotalPosts>
              {category.posts.nodes.length}
            </SCategoryTotalPosts>
          </SCategoryItem>
        );
      })}
      <SAllLink to="/blog/categories/">All Categories</SAllLink>
    </SSection>
  );
}

BlogCategoryListCard.propTypes = {};

export default BlogCategoryListCard;
